import { render, staticRenderFns } from "./cleanCache.vue?vue&type=template&id=494a6b82&scoped=true&"
import script from "./cleanCache.vue?vue&type=script&lang=js&"
export * from "./cleanCache.vue?vue&type=script&lang=js&"
import style0 from "./cleanCache.vue?vue&type=style&index=0&id=494a6b82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a6b82",
  null
  
)

export default component.exports